import { render, staticRenderFns } from "./NewBookForm.vue?vue&type=template&id=3b072a8b"
import script from "./NewBookForm.vue?vue&type=script&lang=js"
export * from "./NewBookForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports